/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter2 from "components/Card/CardFooter.js";
import { CardFooter } from "reactstrap";
import TSSelect from "components/Forms/TSSelect";
import { Collapse, Modal, ModalBody } from "reactstrap";
import Table from "components/Table/TableAdmin";
import Pagination from "react-responsive-pagination";
import Checkbox from "@material-ui/core/Checkbox";
import axios from "utils/httpClient";
import { useDispatch, useSelector } from "react-redux";
// import avatar from "assets/img/faces/marc.jpg";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);

export default function UserProfile() {
  const user = useSelector((state) => state.auth.user);
  const [clear, setClear] = useState(false);
  const [name, setName] = useState("");
  const [data1, setData1] = useState("");
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");
  const [year, setYear] = useState("");
  const [dataGroup, setDataGroup] = useState(0);
  const [m1Value1, setM1Value1] = useState("");
  const [m2Value1, setM2Value1] = useState("");
  const [m3Value1, setM3Value1] = useState("");
  const [m4Value1, setM4Value1] = useState("");
  const [m5Value1, setM5Value1] = useState("");
  const [m6Value1, setM6Value1] = useState("");
  const [m7Value1, setM7Value1] = useState("");
  const [m8Value1, setM8Value1] = useState("");
  const [m9Value1, setM9Value1] = useState("");
  const [m10Value1, setM10Value1] = useState("");
  const [m11Value1, setM11Value1] = useState("");
  const [m12Value1, setM12Value1] = useState("");
  const [dataOId, setDataOId] = useState(0);
  const [optionsYear, setOptionsYear] = useState([]);
  const [optionsDataGroup, setOptionsDataGroup] = useState([]);
  const [modalDelete, setModalDelete] = useState(false);
  const [tableHead, setTableHead] = useState([]);
  const [pageSize] = useState(10);
  const [data, setData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isFecth, setIsFecth] = useState(false);
  const [isHorizontal, setIsHorizontal] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const windowWidth = useWindowWidth();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [idOther, setIdOther] = useState(0);
  const [isFinishAdd, setIsFinishAdd] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isAdd2, setIsAdd2] = useState(false);
  const [oldYear, setOldYear] = useState("");

  // const optionsYear = [
  //   { value: "2563", label: "2563" },
  //   { value: "2562", label: "2562" },
  //   { value: "2561", label: "2561" },
  //   { value: "2560", label: "2560" },
  //   { value: "2559", label: "2559" },
  //   { value: "2558", label: "2558" }
  // ];

  var currentUser = JSON.parse(localStorage.getItem('currentUser'))

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if (name === null || name === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อข้อมูล"}</li>);
    }
    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      if (isEdit) {
        setModal3(true);
      } else if (isAdd2) {
        setModal(true);
      }
    }
  };

  const onEdit = e => {
    setIsEdit(e);
    setIsAdd(false);
    setIsAdd2(false);
  };
  // ครั้งที่ 1
  // useEffect(() => {
  //   if(idOther !== 0 && !isAdd && !isAdd2){

  //     .then(response => response.json())
  //     .then(
  //       result => {
  //         setName(result.data.name);
  //         setDataOId(result.data.dataOId)
  //         setIsFecth(result.data.isFetch)
  //         setIsHorizontal(result.data.isHorizontal)
  //         if(!result.data.isFetch) {


  //             " /api/v1/dataOtherOptions?dataOId=" + idOther +
  //             "&year=" +
  //             year ,
  //             {
  //               method: "GET"
  //             }
  //           )
  //           .then(response => response.json())
  //           .then(
  //           result => {
  //             // console.log(result);
  //             setOptionsDataGroup(result);
  //             setIsDefault(false);
  //                   // while(optionsDataGroup.length > 0) {
  //                   //   optionsDataGroup.pop();
  //                   // }
  //                   // result.forEach(e => {
  //                   //   optionsDataGroup.push(e);
  //                   // });
  //               },
  //               error => {

  //               }
  //             );

  //           "/api/v1/dataOther/month?dataOId=" +
  //             result.data.dataOId +
  //             "&year=" +
  //             year +
  //             "&dataGroup=" +
  //             dataGroup,
  //           {
  //             method: "GET"
  //           }
  //         )
  //           .then(response => response.json())
  //           .then(
  //             result => {
  //                 setData1(result.data[0].name);
  //                 setM1Value1(result.data[0].value);
  //                 setM2Value1(result.data[1].value);
  //                 setM3Value1(result.data[2].value);
  //                 setM4Value1(result.data[3].value);
  //                 setM5Value1(result.data[4].value);
  //                 setM6Value1(result.data[5].value);
  //                 setM7Value1(result.data[6].value);
  //                 setM8Value1(result.data[7].value);
  //                 setM9Value1(result.data[8].value);
  //                 setM10Value1(result.data[9].value);
  //                 setM11Value1(result.data[10].value);
  //                 setM12Value1(result.data[11].value);
  //             },
  //             error => {
  //               //var t = optionsDataGroup.find(x => x.value === dataGroup)
  //               setData1("");
  //               setIsDefault(true);
  //               setDataGroup(0);
  //             }
  //           );
  //         }
  //       },
  //       error => {
  //         console.log(error);
  //       }
  //     );
  //   }
  // }, [isEdit, idOther, dataGroup, year]);

  useEffect(() => {
    const fetchData = async () => {
      if (idOther !== 0 && !isAdd && !isAdd2) {
        const response = await axios("/api/v1/dataOId/" + idOther);
        const data = response.data;
        setName(data.data.name);
        setDataOId(data.data.dataOId);
        setIsFecth(data.data.isFetch);
        setIsHorizontal(data.data.isHorizontal);
        if (!data.data.isFetch) {
          const response2 = await axios(
            " /api/v1/dataOtherOptions?dataOId=" + idOther + "&year=" + year,
            {
              method: "GET"
            }
          );
          const data2 = response2.data;
          console.log(data2);
          setOptionsDataGroup(data2);

          const response3 = await axios(
            "/api/v1/dataOther/month?dataOId=" +
              data.data.dataOId +
              "&year=" +
              year +
              "&dataGroup=" +
              dataGroup,
            {
              method: "GET"
            }
          );
          if (response3.status !== 200) {
            console.log("");
          } else {
            const data3 = response3.data;
            setData1(data3.data[0].name);
            setM1Value1(data3.data[0].value);
            setM2Value1(data3.data[1].value);
            setM3Value1(data3.data[2].value);
            setM4Value1(data3.data[3].value);
            setM5Value1(data3.data[4].value);
            setM6Value1(data3.data[5].value);
            setM7Value1(data3.data[6].value);
            setM8Value1(data3.data[7].value);
            setM9Value1(data3.data[8].value);
            setM10Value1(data3.data[9].value);
            setM11Value1(data3.data[10].value);
            setM12Value1(data3.data[11].value);
          }
        }
      }
    };

    fetchData().catch(error => console.error(error));
  }, [isEdit, idOther, dataGroup, year]);

  // ครั้งที่2
  //   useEffect(() => {
  //     async function fetchData() {
  //         try {
  //           if(idOther !== 0 && !isAdd && !isAdd2){

  //             .then(response => response.json())
  //             .then(
  //               result => {
  //                 setName(result.data.name);
  //                 setDataOId(result.data.dataOId)
  //                 setIsFecth(result.data.isFetch)
  //                 setIsHorizontal(result.data.isHorizontal)
  //                 if(!result.data.isFetch) {


  //                     " /api/v1/dataOtherOptions?dataOId=" + idOther +
  //                     "&year=" +
  //                     year ,
  //                     {
  //                       method: "GET"
  //                     }
  //                   )
  //                   .then(response => response.json())
  //                   .then(
  //                   result => {
  //                     // console.log(result);
  //                     setOptionsDataGroup(result);
  //                     setIsDefault(false);
  //                           // while(optionsDataGroup.length > 0) {
  //                           //   optionsDataGroup.pop();
  //                           // }
  //                           // result.forEach(e => {
  //                           //   optionsDataGroup.push(e);
  //                           // });
  //                       },
  //                       error => {

  //                       }
  //                     );

  //                   "/api/v1/dataOther/month?dataOId=" +
  //                     result.data.dataOId +
  //                     "&year=" +
  //                     year +
  //                     "&dataGroup=" +
  //                     dataGroup,
  //                   {
  //                     method: "GET"
  //                   }
  //                 )
  //                   .then(response => response.json())
  //                   .then(
  //                     result => {
  //                         setData1(result.data[0].name);
  //                         setM1Value1(result.data[0].value);
  //                         setM2Value1(result.data[1].value);
  //                         setM3Value1(result.data[2].value);
  //                         setM4Value1(result.data[3].value);
  //                         setM5Value1(result.data[4].value);
  //                         setM6Value1(result.data[5].value);
  //                         setM7Value1(result.data[6].value);
  //                         setM8Value1(result.data[7].value);
  //                         setM9Value1(result.data[8].value);
  //                         setM10Value1(result.data[9].value);
  //                         setM11Value1(result.data[10].value);
  //                         setM12Value1(result.data[11].value);
  //                     },
  //                     error => {
  //                       //var t = optionsDataGroup.find(x => x.value === dataGroup)
  //                       setData1("");
  //                       setIsDefault(true);
  //                       setDataGroup(0);
  //                     }
  //                   );
  //                 }
  //               },
  //               error => {
  //                 console.log(error);
  //               }
  //             );
  //           }
  //         } catch (e) {
  //             console.error(e);
  //         }
  //     };
  //     fetchData();
  // }, [isEdit, idOther, dataGroup, year]);

  useEffect(() => {
    setClear(true);
    setData1("");
  }, [dataGroup, year]);

  useEffect(() => {
    setOldYear(year);
  }, [year]);

  useEffect(() => {}, [currentPage]);

  const onDelete = e => {
    setModalDelete(true);
  };

  const handleDelete = evt => {
    evt.preventDefault();
    var cntErr = 0;
    var errMsg = [];

    if (dataGroup === 0) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาเลือกชุดข้อมูล"}</li>);
    }
    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
      axios(
        "/api/v1/dataOther?dataOId=" + dataOId + "&dataGroup=" + dataGroup,
        {
          method: "DELETE",
          responseType: "text"
        }
      )
        .then(response => response.data)
        .then(
          result => {
            var myBool = String("") === result;
            if (!myBool) {
              setModalDelete(false);
              setIcon("far fa-question-circle");
              var errMsg = [];
              var cntErr = 0;

              cntErr += 1;
              errMsg.push(
                <li key={cntErr - 1}>{"เกิดข้อผิดพลาดกรุณาลองใหม่"}</li>
              );

              setErrMsg(errMsg);
              setModalError(true);
            } else {
              setModalDelete(false);
              setIcon("far fa-question-circle");
              setClear(true);
              setData1("");
              axios(
                " /api/v1/dataOtherOptions?dataOId=" +
                  idOther +
                  "&year=" +
                  year,
                {
                  method: "GET"
                }
              )
                .then(response => response.data)
                .then(
                  result => {
                    setOptionsDataGroup(result);
                    // while(optionsDataGroup.length > 0) {
                    //   optionsDataGroup.pop();
                    // }
                    // result.forEach(e => {
                    //   optionsDataGroup.push(e);
                    // });
                  },
                  error => {}
                );
            }
          },
          error => {
            alert(error);
          }
        );
    }
  };

  // React.useMemo(() => {
  //   console.log('Filter function is running ...');
  // }, [dataGroup]);

  function useWindowWidth() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth - 400);

    useEffect(() => {
      const resizeHandler = () => {
        setWindowWidth(window.innerWidth - 400);
      };

      window.addEventListener("resize", resizeHandler);
      return () => {
        window.removeEventListener("resize", resizeHandler);
      };
    }, []);
    return windowWidth;
  }

  const onSelected = e => {
    setIdOther(e);
  };

  const handleSubmitMonth = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];
    if (
      (m1Value1 === null || m1Value1 === "") &&
      (m2Value1 === null || m2Value1 === "") &&
      (m3Value1 === null || m3Value1 === "") &&
      (m4Value1 === null || m4Value1 === "") &&
      (m5Value1 === null || m5Value1 === "") &&
      (m6Value1 === null || m6Value1 === "") &&
      (m7Value1 === null || m7Value1 === "") &&
      (m9Value1 === null || m8Value1 === "") &&
      (m9Value1 === null || m9Value1 === "") &&
      (m10Value1 === null || m10Value1 === "") &&
      (m11Value1 === null || m11Value1 === "") &&
      (m12Value1 === null || m12Value1 === "")
    ) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุค่าอย่างน้อย 1 เดือน"}</li>);
    }

    if (data1 === "" || data1 === null) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อชุดข้อมูล"}</li>);
    }
    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal2(true);
    }
  };

  const handleSubmitMonthUpdate = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal4(true);
    }
  };

  const isCheck = () => {
    if (isAdd) {
      return [{ value: "", label: "" }];
    } else if (isFinishAdd) {
      var l = optionsDataGroup.length;
      return [optionsDataGroup[l - 1]];
    } else if (modalDelete) {
      return [{ value: "", label: "" }];
    } else if (year !== oldYear) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheckYear = () => {
    if (year === "") {
      return [optionsYear[0]];
    } else var value = optionsYear.filter(p => p.value === year);
    return [value[0]];
  };

  const setBoth = () => {
    setIsAdd(true);
    setDisable(true);
    setIsEdit(false);
    setData1("");
    setClear(true);
  };

  useEffect(() => {
    axios("/api/v1/year/")
      .then(response => response.data)
      .then(
        result => {
          result.forEach(e => {
            optionsYear.push(e);
          });
        },
        error => {
          console.log(error);
        }
      );

    tableHead.push("ชื่อ", "แก้ไข");
  }, []);

  useEffect(() => {

    //   "/api/v1/tableOther/" +
    //     "/pagination?PageNumber=" +
    //     currentPage +
    //     "&PageSize=" +
    //     pageSize
    // )
    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       var tableList = [];
    //       if (result.data.length > 0) {
    //         var name;
    //         result.data.forEach(e => {
    //           name = e.name;
    //           var dataOId = e.dataOId;
    //           tableList.push([name, "edit", dataOId]);
    //         });
    //       }

    //       setData(tableList);
    //       var total = result.total / pageSize;
    //       if (!Number.isInteger(total)) {
    //         setTotalPages((total | 0) + 1);
    //       } else if (total === 0) {
    //         setTotalPages(1);
    //       } else {
    //         setTotalPages(total);
    //       }
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   );

      axios("/api/v1/tableOther/" +
      "/pagination?PageNumber=" +
      currentPage +
      "&PageSize=" +
      pageSize)
      .then(
        result => {
          var res = result.data;
          var tableList = [];
          if (res.data.length > 0) {
            var name;
            res.data.forEach(e => {
              name = e.name;
              var dataOId = e.dataOId;
              tableList.push([name, "edit", dataOId]);
            });
          }

          setData(tableList);
          var total = res.total / pageSize;
          if (!Number.isInteger(total)) {
            setTotalPages((total | 0) + 1);
          } else if (total === 0) {
            setTotalPages(1);
          } else {
            setTotalPages(total);
          }
        
        }, error => {console.log(error);}
      );  
  }, [currentPage]);

  useEffect(() => {
    if (clear) {
      setM1Value1("");
      setM2Value1("");
      setM3Value1("");
      setM4Value1("");
      setM5Value1("");
      setM6Value1("");
      setM7Value1("");
      setM8Value1("");
      setM9Value1("");
      setM10Value1("");
      setM11Value1("");
      setM12Value1("");
      setClear(false);
    }
  }, [clear]);

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    // const requestOptions = {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json-patch+json"
    //   },
    //   body: JSON.stringify({
    //     Name: name,
    //     IsHorizontal: isHorizontal
    //   })
    // };


    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setModal(false);
    //       setIdOther(result.data.dataOId);
    //       setIcon("far fa-question-circle");
    //       setIsAdd2(false);
    //       setIsEdit(true);


    //         "/api/v1/tableOther/" +
    //           "/pagination?PageNumber=" +
    //           currentPage +
    //           "&PageSize=" +
    //           pageSize
    //       )
    //         .then(response => response.json())
    //         .then(
    //           result => {
    //             var tableList = [];
    //             if (result.data.length > 0) {
    //               var name;
    //               result.data.forEach(e => {
    //                 name = e.name;
    //                 var dataOId = e.dataOId;
    //                 tableList.push([name, "edit", dataOId]);
    //               });
    //             }

    //             setData(tableList);
    //             var total = result.total / pageSize;
    //             if (!Number.isInteger(total)) {
    //               setTotalPages((total | 0) + 1);
    //             } else if (total === 0) {
    //               setTotalPages(1);
    //             } else {
    //               setTotalPages(total);
    //             }
    //           },
    //           error => {
    //             console.log(error);
    //           }
    //         );
    //     },
    //     error => {
    //       alert(error);
    //     }
    //   );

    var js = {
      Name: name,
      IsHorizontal: isHorizontal,
      creatorCode: currentUser.userName,
      LastediterCode: currentUser.userName
     }
     
     axios.post("/api/v1/dataOther", js)
     .then (
       result => {
          var res = result.data;
          setModal(false);
          setIdOther(res.data.dataOId);
          setIcon("far fa-question-circle");
          setIsAdd2(false);
          setIsEdit(true);
          axios(
              "/api/v1/tableOther/" +
              "/pagination?PageNumber=" +
              currentPage +
              "&PageSize=" +
              pageSize
              )
              .then(response => response.data)
              .then(
                result2 => {
                  var tableList = [];
                  if (result2.data.length > 0) {
                    var name;
                    result2.data.forEach(e => {
                    name = e.name;
                    var dataOId = e.dataOId;
                    tableList.push([name, "edit", dataOId]);
                    });
                  }
        
                  setData(tableList);
                  var total = result2.total / pageSize;
                  if (!Number.isInteger(total)) {
                    setTotalPages((total | 0) + 1);
                  } else if (total === 0) {
                    setTotalPages(1);
                  } else {
                    setTotalPages(total);
                  }
                },
                  error => {
                  console.log(error);
              }
            );
          },
       error => { console.log(error);}
     );
  };

  const handleConfirmUpdate = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    var edit = {
      Name: name,
      IsHorizontal: isHorizontal,
      LastediterCode: currentUser.userName
    };


    //   method: "PUT",
    //   headers: { "Content-Type": "application/json-patch+json" },
    //   body: JSON.stringify(edit)
    // })
    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setModal3(false);
    //       setDataOId(result.data.dataOId);
    //       setIcon("far fa-question-circle");
    //     },
    //     error => {
    //       alert(error);
    //     }
    //   );

      axios.put("/api/v1/dataOther/" + dataOId, edit)
      .then (
        result => {
          setModal3(false);
          setDataOId(result.data.dataOId);
          setIcon("far fa-question-circle");
        },
        error => { console.log(error);}
      );
  };

  const handleConfirmMonth = evt => {
    evt.preventDefault();
    setIcon2("fa fa-spinner fa-w-16 fa-spin fa-lg");

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      data: {
        Name: data1,
        DataOId: dataOId,
        Year: year,
        M1Value1: m1Value1,
        M2Value1: m2Value1,
        M3Value1: m3Value1,
        M4Value1: m4Value1,
        M5Value1: m5Value1,
        M6Value1: m6Value1,
        M7Value1: m7Value1,
        M8Value1: m8Value1,
        M9Value1: m9Value1,
        M10Value1: m10Value1,
        M11Value1: m11Value1,
        M12Value1: m12Value1
      }
    };

    axios("/api/v1/dataSetOther", requestOptions)
      .then(response => response.data)
      .then(
        result => {
          setModal2(false);
          setIcon2("far fa-question-circle");
          axios(
            " /api/v1/dataOtherOptions?dataOId=" + idOther + "&year=" + year,
            {
              method: "GET"
            }
          )
            .then(response => response.data)
            .then(
              result => {
                setOptionsDataGroup(result);
              },
              error => {}
            );

          setIsAdd(false);
          setDisable(false);
          setIsEdit(true);
          setIsFinishAdd(true);
          setDataGroup(result);

          axios(
            "/api/v1/dataOther/month?dataOId=" +
              idOther +
              "&year=" +
              year +
              "&dataGroup=" +
              result,
            {
              method: "GET"
            }
          )
            .then(response => response.data)
            .then(
              result2 => {
                //setClear(true);
                setM1Value1(result2.data[0].value);
                setM2Value1(result2.data[1].value);
                setM3Value1(result2.data[2].value);
                setM4Value1(result2.data[3].value);
                setM5Value1(result2.data[4].value);
                setM6Value1(result2.data[5].value);
                setM7Value1(result2.data[6].value);
                setM8Value1(result2.data[7].value);
                setM9Value1(result2.data[8].value);
                setM10Value1(result2.data[9].value);
                setM11Value1(result2.data[10].value);
                setM12Value1(result2.data[11].value);
                setYear(result2.data[0].year);
                setData1(result2.data[0].name);
                setDataGroup(result2.data[0].dataGroup);
                setIsFinishAdd(false);
              },
              error => {
                alert(error);
              }
            );
        },
        error => {
          alert(error);
        }
      );
  };

  const setBoth2 = () => {
    setIsAdd2(true);
    setName("");
    setIsEdit(false);
    setIsAdd(false);
    // setIsEdit2(false);
    // setName2("");
  };

  const handleConfirmMonthUpdate = evt => {
    evt.preventDefault();
    setIcon2("fa fa-spinner fa-w-16 fa-spin fa-lg");

    var edit = {
      Name: data1,
      DataOId: dataOId,
      Year: year,
      DataGroup: dataGroup,
      M1Value1: m1Value1,
      M2Value1: m2Value1,
      M3Value1: m3Value1,
      M4Value1: m4Value1,
      M5Value1: m5Value1,
      M6Value1: m6Value1,
      M7Value1: m7Value1,
      M8Value1: m8Value1,
      M9Value1: m9Value1,
      M10Value1: m10Value1,
      M11Value1: m11Value1,
      M12Value1: m12Value1
    };

    axios("/api/v1/dataOther/month/" + dataOId, {
      method: "PUT",
      headers: { "Content-Type": "application/json-patch+json" },
      data: edit
    })
      .then(response => response.data)
      .then(
        result => {
          setModal4(false);
          setIcon2("far fa-question-circle");
          axios(
            "/api/v1/dataOther/month?dataOId=" +
              result.data.dataOId +
              "&year=" +
              year +
              "&dataGroup=" +
              dataGroup,
            {
              method: "GET"
            }
          )
            .then(response => response.data)
            .then(
              result2 => {
                setData1(result2.data[0].name);
                setM1Value1(result2.data[0].value);
                setM2Value1(result2.data[1].value);
                setM3Value1(result2.data[2].value);
                setM4Value1(result2.data[3].value);
                setM5Value1(result2.data[4].value);
                setM6Value1(result2.data[5].value);
                setM7Value1(result2.data[6].value);
                setM8Value1(result2.data[7].value);
                setM9Value1(result2.data[8].value);
                setM10Value1(result2.data[9].value);
                setM11Value1(result2.data[10].value);
                setM12Value1(result2.data[11].value);
                setDataGroup(result2.data[1].dataGroup);
              },
              error => {
                alert(error);
              }
            );
        },
        error => {
          alert(error);
        }
      );
  };

  const handleClick = () => {
    setIsHorizontal(!isHorizontal);
  };

  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info">
              <h4 className={classes.cardTitleWhite}>Simple Table</h4>
              <p className={classes.cardCategoryWhite}>
                Here is a subtitle for this table
              </p>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: "center" }}
                >
                  <Button color="info" type="button" onClick={setBoth2}>
                    <h4>เพิ่ม</h4>
                  </Button>
                </GridItem>
              </GridContainer>
              <Table
                tableHeaderColor="info"
                tableHead={tableHead}
                tableData={data}
                isEdit={onEdit}
                isDelete={onDelete}
                select={onSelected}
              />
            </CardBody>
            <CardFooter>
              <Pagination
                current={currentPage}
                total={totalPages}
                onPageChange={setCurrentPage}
                maxWidth={windowWidth}
              />
            </CardFooter>
          </Card>
        </GridItem>

        {(isEdit || isAdd || isAdd2) && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info">
                <h4 className={classes.cardTitleWhite}>Simple Table</h4>
                <p className={classes.cardCategoryWhite}>
                  Here is a subtitle for this table
                </p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="ชื่อ"
                      id="name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setName(e)}
                      value={name}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div>
                      <h4 className={classes.cardTitleWhite}>-</h4>
                      <h4 style={{ display: "contents" }}>แสดงกราฟแนวนอน</h4>
                      <Checkbox
                        checked={isHorizontal}
                        onClick={event => {
                          handleClick();
                        }}
                      />
                    </div>
                  </GridItem>
                </GridContainer>
              </CardBody>
              <GridContainer>
                {/* Confirm */}
                <Modal toggle={() => setModal(false)} isOpen={modal}>
                  <div className="modal-header justify-content-center">
                    <div>
                      <i
                        className={icon}
                        style={{ color: "blue", fontSize: "2em" }}
                      ></i>
                    </div>
                  </div>
                  <ModalBody>
                    <p
                      style={{
                        textAlign: "center"
                      }}
                    >
                      {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        ? "ยืนยันการบันทึกข้อมูล"
                        : "กำลังตรวจสอบข้อมูล"}
                    </p>
                    <p> </p>
                  </ModalBody>
                  <div className="modal-footer">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => setModal(false)}
                    >
                      <h4>ยกเลิก</h4>
                    </Button>

                    <Button
                      color="primary"
                      type="button"
                      onClick={handleConfirm}
                      disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                    >
                      <h4>ยืนยัน</h4>
                    </Button>
                  </div>
                </Modal>

                <Modal toggle={() => setModal3(false)} isOpen={modal3}>
                  <div className="modal-header justify-content-center">
                    <div>
                      <i
                        className={icon}
                        style={{ color: "blue", fontSize: "2em" }}
                      ></i>
                    </div>
                  </div>
                  <ModalBody>
                    <p
                      style={{
                        textAlign: "center"
                      }}
                    >
                      {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        ? "ยืนยันการบันทึกข้อมูล"
                        : "กำลังตรวจสอบข้อมูล"}
                    </p>
                    <p> </p>
                  </ModalBody>
                  <div className="modal-footer">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => setModal3(false)}
                    >
                      <h4>ยกเลิก</h4>
                    </Button>

                    <Button
                      color="primary"
                      type="button"
                      onClick={handleConfirmUpdate}
                      disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                    >
                      <h4>ยืนยัน</h4>
                    </Button>
                  </div>
                </Modal>

                {/* Error */}
                <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                  <div className="modal-header justify-content-center">
                    <div>
                      <i
                        className="fa fa-times"
                        style={{ color: "red", fontSize: "2em" }}
                      ></i>
                    </div>
                  </div>
                  <ModalBody>
                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                    <div>{errMsg}</div>
                  </ModalBody>
                  <div className="modal-footer justify-content-center">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => setModalError(false)}
                    >
                      <h4>ตกลง</h4>
                    </Button>
                  </div>
                </Modal>
              </GridContainer>
              <CardFooter style={{ textAlign: "center" }}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="info" onClick={handleSubmit}>
                      {(isAdd || isAdd2) && <h4>บันทึก</h4>}
                      {isEdit && <h4>แก้ไข</h4>}
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardFooter>
            </Card>
          </GridItem>
        )}

        {/* <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <a href="#pablo" onClick={e => e.preventDefault()}>
                <img src={avatar} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
              <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
              <h4 className={classes.cardTitle}>Alec Thompson</h4>
              <p className={classes.description}>
                Don{"'"}t be scared of the truth because we need to restart the
                human foundation in truth And I love you like Kanye loves Kanye
                I love Rick Owens’ bed design but the back is...
              </p>
              <Button color="primary" round>
                Follow
              </Button>
            </CardBody>
          </Card>
        </GridItem> */}
      </GridContainer>
      {(isEdit || isAdd) && !isFecth && (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info">
                <h4 className={classes.cardTitleWhite}>เพิ่มข้อมูล</h4>
                <p className={classes.cardCategoryWhite}>กรุณากรอกข้อมูล</p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      options={optionsYear}
                      zIndex={999}
                      onChange={e => setYear(e)}
                      default={optionsYear[0]}
                      defaulfAdd={isCheckYear()}
                    />
                  </GridItem>
                </GridContainer>
                <div style={{ paddingTop: "10px" }}></div>
                <GridContainer>
                  <GridItem xs={6} sm={6} md={6}>
                    <TSSelect
                      options={optionsDataGroup}
                      zIndex={998}
                      disabled={disable}
                      onChange={e => setDataGroup(e)}
                      defaulfAdd={isCheck()}
                      year={year}
                      idOther={idOther}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={6} style={{ height: "48px" }}>
                    <div style={{ textAlign: "center", overflow: "overlay" }}>
                      <Button color="info" onClick={() => setBoth()}>
                        <h4>เพิ่มชุดข้อมูล</h4>
                      </Button>
                      <Button color="danger" onClick={onDelete}>
                        <h4>ลบชุดข้อมูล</h4>
                      </Button>
                    </div>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  {isAdd && (
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="ชื่อชุดข้อมูล"
                        id="data1"
                        formControlProps={{
                          fullWidth: true
                        }}
                        onChange={e => setData1(e)}
                        value={data1}
                        // inputProps={{
                        //   disabled: true
                        // }}
                      />
                    </GridItem>
                  )}
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนตุลาคม</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="october"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM1Value1(e)}
                      value={m1Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนพฤศจิกายน</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="november"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM2Value1(e)}
                      value={m2Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนธันวาคม</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="december"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM3Value1(e)}
                      value={m3Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนมกราคม</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="่january"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM4Value1(e)}
                      value={m4Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนกุมภาพันธ์</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="่february"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM5Value1(e)}
                      value={m5Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนมีนาคม</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="่march"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM6Value1(e)}
                      value={m6Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนเมษายน</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="april"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM7Value1(e)}
                      value={m7Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนพฤษภาคม</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="may"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM8Value1(e)}
                      value={m8Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนมิถุนายน</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="june"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM9Value1(e)}
                      value={m9Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนกรกฎาคม</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="july"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM10Value1(e)}
                      value={m10Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนสิงหาคม</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="august"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM11Value1(e)}
                      value={m11Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "1.2em" }}
                    xs={12}
                    sm={12}
                    md={2}
                  >
                    <h4 className={classes.CardHeader}>เดือนกันยายน</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={10}>
                    <CustomInput
                      labelText={data1}
                      id="september"
                      formControlProps={{
                        fullWidth: true
                      }}
                      // inputProps={{
                      //   disabled: true
                      // }}
                      onChange={e => setM12Value1(e)}
                      value={m12Value1}
                      numericInput={true}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter2 style={{ justifyContent: "center" }}>
                {isAdd && !isFecth && (
                  <Button color="info" onClick={handleSubmitMonth}>
                    <h4>เพิ่มชุดข้อมูล</h4>
                  </Button>
                )}
                {isEdit && !isFecth && (
                  <Button color="info" onClick={handleSubmitMonthUpdate}>
                    <h4>แก้ไข</h4>
                  </Button>
                )}
                {/* Confirm */}
                <Modal toggle={() => setModal2(false)} isOpen={modal2}>
                  <div className="modal-header justify-content-center">
                    <div>
                      <i
                        className={icon2}
                        style={{ color: "blue", fontSize: "2em" }}
                      ></i>
                    </div>
                  </div>
                  <ModalBody>
                    <p
                      style={{
                        textAlign: "center"
                      }}
                    >
                      {icon2 !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        ? "ยืนยันการบันทึกข้อมูล"
                        : "กำลังตรวจสอบข้อมูล"}
                    </p>
                    <p> </p>
                  </ModalBody>
                  <div className="modal-footer">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => setModal2(false)}
                    >
                      <h4>ยกเลิก</h4>
                    </Button>

                    <Button
                      color="primary"
                      type="button"
                      onClick={handleConfirmMonth}
                      disabled={icon2 === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                    >
                      <h4>ยืนยัน</h4>
                    </Button>
                  </div>
                </Modal>

                <Modal toggle={() => setModal4(false)} isOpen={modal4}>
                  <div className="modal-header justify-content-center">
                    <div>
                      <i
                        className={icon2}
                        style={{ color: "blue", fontSize: "2em" }}
                      ></i>
                    </div>
                  </div>
                  <ModalBody>
                    <p
                      style={{
                        textAlign: "center"
                      }}
                    >
                      {icon2 !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        ? "ยืนยันการบันทึกข้อมูล"
                        : "กำลังตรวจสอบข้อมูล"}
                    </p>
                    <p> </p>
                  </ModalBody>
                  <div className="modal-footer">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => setModal4(false)}
                    >
                      <h4>ยกเลิก</h4>
                    </Button>

                    <Button
                      color="primary"
                      type="button"
                      onClick={handleConfirmMonthUpdate}
                      disabled={icon2 === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                    >
                      <h4>ยืนยัน</h4>
                    </Button>
                  </div>
                </Modal>

                <Modal
                  toggle={() => setModalDelete(false)}
                  isOpen={modalDelete}
                >
                  <div className="modal-header justify-content-center">
                    <div>
                      <i
                        className={icon}
                        style={{ color: "blue", fontSize: "2em" }}
                      ></i>
                    </div>
                  </div>
                  <ModalBody>
                    <p
                      style={{
                        textAlign: "center"
                      }}
                    >
                      {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        ? "ยืนยันการลบข้อมูล"
                        : "กำลังตรวจสอบข้อมูล"}
                    </p>
                    <p> </p>
                  </ModalBody>
                  <div className="modal-footer">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => setModalDelete(false)}
                    >
                      <h4>ยกเลิก</h4>
                    </Button>

                    <Button
                      color="primary"
                      type="button"
                      onClick={handleDelete}
                      disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                    >
                      <h4>ยืนยัน</h4>
                    </Button>
                  </div>
                </Modal>

                {/* Error */}
                <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                  <div className="modal-header justify-content-center">
                    <div>
                      <i
                        className="fa fa-times"
                        style={{ color: "red", fontSize: "2em" }}
                      ></i>
                    </div>
                  </div>
                  <ModalBody>
                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                    <div>{errMsg}</div>
                  </ModalBody>
                  <div className="modal-footer justify-content-center">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => setModalError(false)}
                    >
                      <h4>ตกลง</h4>
                    </Button>
                  </div>
                </Modal>
              </CardFooter2>
            </Card>
          </GridItem>
        </GridContainer>
      )}
    </div>
  );
}
